import { PageController } from '@client/components/_core/layout/PageController';
import { DocumentLibrary } from '@client/components/_shared/documents/DocumentLibrary';
import { COMPLAINT_STATUS } from '@shared/constants';
import { createFileRoute } from '@tanstack/react-router';
import { useComplaintEditAccess } from '../hooks';
import { complaintFormStore } from '../store';

export const Route = createFileRoute('/console/$orgId/compliance/complaints/details/$id/library')({
    component: Library,
});

function Library() {
    const { hasAccess } = useComplaintEditAccess();
    const complaint = complaintFormStore.use.formData();

    return (
        <PageController route={Route}>
            <DocumentLibrary
                entity="complaint"
                readOnly={!hasAccess}
                entityId={complaint.id}
                disableUploading={complaint.status === COMPLAINT_STATUS.CLOSED}
                shouldIncludeRelatedEntities
            />
        </PageController>
    );
}
